export type OntologyStatus = "In Review" | "Published" | "Draft" | "Approved";

export interface OntologyKpi {
  id: string;
  label: string;
  value: string;
  delta: string;
  accent: "positive" | "neutral";
}

export interface OntologyKpiMeta {
  id: string;
  label: string;
}

// Static KPI labels/order matching Figma (node 3589:89392/89400/89408/89416) — only `value` comes from the API.
export const ONTOLOGY_KPI_META: OntologyKpiMeta[] = [
  { id: "active", label: "Active Initiatives" },
  { id: "draft", label: "Draft Initiatives" },
  { id: "awaiting-review", label: "Awaiting Review" },
  { id: "published", label: "Published Ontologies" }
];

export interface PerformanceMetric {
  id: string;
  label: string;
  value: string;
  dotColor: string;
}

export const PERFORMANCE_METRICS: PerformanceMetric[] = [
  {
    id: "cycle-time",
    label: "Avg. Cycle Time",
    value: "6d",
    dotColor: "#ffe600"
  },
  {
    id: "review-sla",
    label: "Review SLA Adherence",
    value: "84%",
    dotColor: "#1d4ed8"
  },
  {
    id: "validation-pass",
    label: "Validation Pass Rate",
    value: "84%",
    dotColor: "#047857"
  },
  {
    id: "reuse-rate",
    label: "Ontology Reuse Rate",
    value: "64%",
    dotColor: "#1d4ed8"
  }
];

export interface OntologyInitiativeRow {
  id: string;
  name: string;
  owner: string;
  currentStage: string;
  businessUnitName: string;
  teamName: string;
  lastUpdated: string;
  status: OntologyStatus;
}

export const ONTOLOGY_TABLE_COLUMNS = [
  "Initiative Name",
  "Owner",
  "Current Stage",
  "Business Unit",
  "Team / Project Group",
  "Last Updated",
  "Status",
  "Action"
];
